module.exports = __webpack_public_path__ + "static/media/girl-5.59573e4e.svg";